<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-0">
        <gg-card-title class="pt-0 pb-0">
          Managing domain {{ domain.domain }}
        </gg-card-title>
      </v-col>
      <v-col cols="12">
        <v-tabs flat background-color="transparent">
          <v-tabs-slider color="green"></v-tabs-slider>
          <v-tab exact :disabled="loading" :to="`/domains/${domainid}`">
            Overview
          </v-tab>
          <v-tab exact :disabled="loading" :to="`/domains/${domainid}/whois`">
            WHOIS
          </v-tab>
          <v-tab exact :disabled="loading" :to="`/domains/${domainid}/nameservers`">
            Nameservers
          </v-tab>
        </v-tabs>
        <hr class="mt-0">
      </v-col>
      <v-col class="xs-12" >
        <gg-loading :loading="loading" type="table">
          <router-view />
        </gg-loading>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { serviceManagable } from '@/helpers/helpers'

export default {
  name: 'DomainSingle',
  data: () => ({
    loading: false,
  }),
  props: {
    domainid: {
      type: [String, Number],
      required: true,
    }
  },
  computed: mapGetters(['domain']),
  methods: {
    ...mapActions(['showDomain', 'reportError']),
    async getDomain () {
      this.loading = true
      try {
        await this.showDomain(this.domainid)
      } catch (e) {
        this.$router.push({ name: 'domains' })
        this.reportError(e)
      }
      this.loading = false
    }
  },
  created () {
    if (!serviceManagable(this.domain)) {
      this.$router.push({ name: 'domains' })
      return
    }
    this.getDomain()
  }
}
</script>
